function getDefaultSwapchainTask(scene, surface) {
  for (const task of scene._frameGraph._tasks) {
    if (task?._config && task._colorAttachment && (task._config.rt === surface.scRT || task._config.rst === surface.scRT)) {
      return task;
    }
  }
}
function configureSwapchainOverlayScene(surface, overlay) {
  const baseScene = surface._renderingContexts[surface._renderingContexts.length - 1];
  if (!baseScene?._frameGraph) {
    return;
  }
  const overlayTask = getDefaultSwapchainTask(overlay, surface);
  if (!overlayTask) {
    return;
  }
  if (surface.msaaSamples === 1) {
    overlayTask._config.clr = false;
    return;
  }
  const enabled = overlayTask.enabled;
  overlayTask._config.clr = true;
  overlayTask.enabled = false;
  overlay._beforeRender.unshift(() => {
    const baseTask = getDefaultSwapchainTask(baseScene, surface);
    const view = baseTask?._config.rst === surface.scRT && baseTask._config.rt._colorView;
    overlayTask.enabled = view ? enabled : false;
    overlayTask._config.clr = !view;
    if (view) {
      overlayTask._colorAttachment.view = view;
    }
  });
}

export { configureSwapchainOverlayScene };
//# sourceMappingURL=swapchain-overlay.js.map
